
import {
  defineComponent, shallowRef, onMounted, ref, watch, computed, onUnmounted,
} from 'vue';
import * as echarts from 'echarts';
import 'echarts-gl';

import store from '@/store';

import {
  getMapJson,
} from '../caronMonit';
import moment from 'moment';

export default defineComponent({
  setup () {
    // 折线图
    const mapChart = shallowRef<any>({});
    // 数据
    const mapData = computed(() => store.state.caron.mapData);
    const title = ref<string>('各区域碳通量分布');
    // 地图json数据
    let features :any[] = [];

    // const { regionId, } = store.state.OLMap;

    // 焦作regionId TODO 测试数据
    const regionId = '410800000000';

    // 配置项
    const mapOption = {
      tooltip: {
        trigger: 'item',
      },
      geo3D: {
        map: 'map',
        show: false,
        label: {
          show: true,
          color: '#000',
        },
        itemStyle: {
          // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
          borderWidth: 0.5,
          // 图形描边的颜色。[ default: #333 ]
          borderColor: '#000',
        },
        viewControl: {
          // 默认视角距离主体的距离
          distance: 135,
          // 视角绕 x 轴
          alpha: 40,
          // 视角绕 y 轴
          beta: 0,
        },
      },
      visualMap: {
        show: true,
        left: 'right',
        min: 0,
        max: 1,
        inRange: {
          color: [
            '#313695',
            '#4575b4',
            '#74add1',
            '#abd9e9',
            '#e0f3f8',
            '#ffffbf',
            '#fee090',
            '#fdae61',
            '#f46d43',
            '#d73027',
            '#a50026',
          ],
        },
        text: ['High', 'Low',],
        textStyle: {
          color: '#222',
        },
        calculable: false,
        seriesIndex: 0,
      },
      series: [
        {
          // 系列类型
          type: 'map3D',
          name: '碳通量浓度',
          map: 'map',
          data: [] as any[],
          label: {
            show: true,
            color: '#fff',
          },
          itemStyle: {
            // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
            borderWidth: 0.5,
            // 图形描边的颜色。[ default: #333 ]
            borderColor: '#fff',
          },
          viewControl: {
            // 默认视角距离主体的距离
            distance: 100,
            // 视角绕 x 轴
            alpha: 40,
            // 视角绕 y 轴
            beta: 0,
            // 中心点
            center: [0,
              -20,
              0,],
          },
        },
      ],
    };

    const initChart = () => {
      const mapChartContainer = document.getElementById('caron-map-chart') as HTMLElement;

      mapChart.value = echarts.init(mapChartContainer);
    };
    const drawChart = (data:any): void => {
      const temp :any[] = [];
      const tempValue:any[] = [];
      const initMax = 1;
      const initMin = 0;

      Object.keys(data).forEach((item) => {
        // 地图数据区域名匹配：以Json数据为准，匹配区域名前两位
        const addressIndex = features.findIndex((area:any) => area.properties.name.toString().substring(0,2) === item.substring(0,2));

        if (addressIndex >= 0) {
          const { name, } = features[addressIndex].properties;

          temp.push({ name, value: data[item], });
        }
        tempValue.push(data[item]);
      });

      const tempMax = Math.ceil(Math.max(...tempValue));
      const tempMin = Math.floor(Math.min(...tempValue));

      mapOption.visualMap.max = tempMax < initMax ?
        initMax :
        tempMax;
      mapOption.visualMap.min = tempMin < initMin ?
        tempMin :
        initMin;
      mapOption.series[0].data = temp;
      mapChart.value.setOption(mapOption);
    };

    watch(mapData,(val:any) => {
      if (Object.keys(val).length && val.data) {
        drawChart(val.data);
        title.value = `${moment(val.curDate).format('YYYY年MM月DD日') + val.type}分布`;
      }
    },{ deep: true, });

    onMounted(() => {
      initChart();
      getMapJson(regionId).then((res:any) => {
        echarts.registerMap('map', res);
        features = res.features;
        drawChart({});
      });
    });

    onUnmounted(() => {
      echarts.dispose(mapChart.value);
      mapChart.value = null;
    });

    return {
      mapData,
      title,
    };
  },
});
